module.exports = __webpack_public_path__ + "img/331.7a63301d.jpg";